import { Badge } from "V2.0/common/badge";

export enum STATUS {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

const STATUS_LABEL = {
  [STATUS.ACTIVE]: "Active",
  [STATUS.ARCHIVED]: "Archived",
};

const STATUS_LABEL_COLORS = {
  [STATUS.ACTIVE]: "green",
  [STATUS.ARCHIVED]: "pink",
};

export default function CampaignStatusBadge(props) {
  const { status } = props;

  const color = STATUS_LABEL_COLORS[status];
  const label = STATUS_LABEL[status];

  return <Badge color={color}>{label}</Badge>;
}
